/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.21.0
 */

import { ROUTE_CAMPAIGN_ID, RoutePath } from '@/main/routes/constants/routesConstants';

import { ITableLinkProps } from './types';

export const useTableCellCampaignInfo = (id: string, value: string): ITableLinkProps => {

    return {
        url: RoutePath.campaignInfo.replace(ROUTE_CAMPAIGN_ID, id),
        children: value,
        noValue: !id || !value,
    };
};
